module.exports = __webpack_public_path__ + "img/logo.15900d46.svg";